module.exports = __webpack_public_path__ + "static/media/self-aligning-bearing.819881b3.jpg";